module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("When Heroes Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("By Andrew Q. Gordon")]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_vm._v("Champion of the Gods: Book Five")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("It took the Seven to create the world, each to rule Their own, until Neldin sought to rule it all.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("The Six defeated Neldin three millennia ago, but time has no meaning to a god. Before the dust settled from the first conflict, both sides set in motion plans for the next one. As Champion of the Six, Farrell, with Kel’s help, gathers those loyal to the Six to meet Meglar and his army.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("But Neldin plotted as well, and like the Six, His plans all lead to the final confrontation between Champions.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Kel teaches Farrell that weapons and power will not be enough—victory requires something from within each Champion. But Neldin also knows this and unleashes a final surprise at a critical moment that claims some of those Farrell loves most.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("With the fate of Nendor riding on his actions, Farrell must ignore the pain and find the will to win. If not, his world and everyone he loves will fall to Meglar’s darkness.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-999abe44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0002.vue
// module id = 60
// module chunks = 0